module.exports = __webpack_public_path__ + "img/3.0d1a2988.png";